// these are put here so I don't have to change the code

if (process.env.REACT_APP_NODE_ENV === 'production') {
  module.exports = require('./url_prod');
} else {
  module.exports = require('./url_dev');
}